
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sic-location-teaser{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-04);
  padding:var(--spacing-06) 0;
  border-bottom:solid 1px var(--color-neutral-default);

  --sic-location-teaser--column-gap:10%;
}

  @media (min-width: 768px){.sic-location-teaser{
    padding-top:var(--spacing-18);
    padding-bottom:var(--spacing-10);
    row-gap:var(--spacing-08);
    min-height:368px
}
  }

slot[name='eyebrow']::slotted(*){
  font-family:var(--ff-body);
  text-transform:uppercase;
}

slot[name='description']::slotted(*){
  --sic-text-color:var(--color-neutral-darkest);
}

.sic-location-teaser--columns{
  display:flex;
  flex-direction:column;
  column-gap:var(--sic-location-teaser--column-gap);
  color:var(--color-neutral-darkest);
}

@media (min-width: 768px){

.sic-location-teaser--columns{
    flex-direction:row
}
  }

@media (min-width: 768px){

.column-wrapper:only-child{
    flex-basis:calc(100%);
    max-width:calc(100%)
}
  }

@media (min-width: 768px){

.column-wrapper:first-child:nth-last-child(2),
.column-wrapper:first-child:nth-last-child(2) ~ .column-wrapper{
    flex-basis:calc((100% / 2) - (var(--sic-location-teaser--column-gap) / 1));
    max-width:calc((100% / 2) - (var(--sic-location-teaser--column-gap) / 1))
}
  }

@media (min-width: 768px){

.column-wrapper:first-child:nth-last-child(3),
.column-wrapper:first-child:nth-last-child(3) ~ .column-wrapper{
    flex-basis:calc((100% / 3) - (var(--sic-location-teaser--column-gap) / 2));
    max-width:calc((100% / 3) - (var(--sic-location-teaser--column-gap) / 2))
}
  }

slot[name*='column-']::slotted(div){
  display:flex;
  flex-direction:column;
  --sic-text-color:var(--color-neutral-darkest);
  font-size:var(--body-01-font-size);
  line-height:var(--body-01-line-height);
}

slot[name='column-3']{
  display:none;
}

@media (min-width: 768px){

slot[name='column-3']{
    display:flex
}
  }
`;